import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { FormBuilder, FormGroup, FormsModule, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms'; // Import this
import { MatRadioModule } from '@angular/material/radio';
import {MatChipsModule} from '@angular/material/chips';
import { getCookie } from '../../../../utils/getCookies';
import { commonEuropeanLanguages } from '../../../../utils/languages';
import { QuillModule } from 'ngx-quill';
import { ViewChild, ElementRef } from '@angular/core';
import { ModalGeneralComponent } from '../../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
interface Language {
  id: number; // or string, depending on your data
  language: string;
  // Add other properties if necessary
}
@Component({
  selector: 'app-step-1',
  standalone: true,
  imports: [MatFormFieldModule, 
    MatSelectModule, MatSliderModule, FormsModule, MatInputModule, MatButtonModule, CommonModule, MatCheckboxModule, ReactiveFormsModule, MatRadioModule, MatChipsModule, QuillModule, TranslateModule],
  templateUrl: './step-1.component.html',
  styleUrl: './step-1.component.scss'
})
export class Step1Component {

  step = 1;
  selectedSeniority = 0;
  location = '';
  remote_days = 0; 
  languages = commonEuropeanLanguages;
  showAllLanguages = false; 
  tree_data: any;
  selectedCategory:  any;
  jobPositions: any;
  selectedJobPositions: any = [];
  selectedLanguages: any = [];
  ubicacions: any;
  origininalKeywordCategoriesData: any  = [];
  keywordsCategories: any;
  selectedKeywordsCategories: any = [];
  filteredKeywordsCategories: any = [];

  capacidadAnalisis: any = [];
  keywords: any = [];
  selectedKeywords: any = "";
  conocimientoTecnico: any;
  selectedLeaderGestion: any;
  selectedLeaderPersonality: any;
  selectedLeaderComportamiento: any;
  capacidadPlanificacion: any;
  selectedDepartmentCualities: any;
  nombre: any = "";
  offerId: any;
  filterJobPositions: any = [];
  min_salary: any = "";
  max_salary: any = "";
  eticaProfesional: any;
  selectedFile: any;
  selectedFileName: any;
  currentOfferFileUrl: any;
  // INIT VALUES
  nameError: boolean = false;
  loading: boolean = false;
  languagesError: boolean = false;
  formHasError: boolean = false;

  generalCategories: any = [
    { "name": "Gestión", "id": 1 },
    { "name": "Gerencia", "id": 2 },
    { "name": "Creativos", "id": 3 },
    { "name": "Datos & Inteligencia Artificial", "id": 4 },
    { "name": "Desarrollo de software", "id": 8 },
    { "name": "Experiencia del usuario", "id": 5 },
    { "name": "Contenido", "id": 6 },
    { "name": "Ventas", "id": 7 },
    { "name": "Formación", "id": 9 },
    { "name": "Legal", "id": 10 },
    { "name": "Marketing", "id": 11 },
    { "name": "Operaciones", "id": 12 },
    { "name": "Recursos humanos", "id": 13 },
    { "name": "Finanzas", "id": 14 },
    { "name": "Comercio electrónico", "id": 16 },
    { "name": "Ingeniería industrial", "id": 19 },
    { "name": "Customer & Business Insights", "id": 20 },
    { "name": "Social Media & Community Management", "id": 21 },
    { "name": "Paid Media", "id": 22 },
    { "name": "Otros", "id": 15 },
  ];

  habilidadesPersonales: any[] = [
    { name: "Responsabilidad", value: "0" },
    { name: "Proactividad", value: "0" },
    { name: "Gestión del tiempo", value: "0" },
    { name: "Capacidad de aprendizaje", value: "0" },
    { name: "Atención al detalle", value: "0" },
    { name: "Manejo del estrés", value: "0" },
    { name: "Orientación a resultados", value: "0" },
    { name: "Creatividad e innovación", value: "0" },
    { name: "Capacidad de análisis", value: "0" },
    { name: "Trabajo en equipo", value: "0" },
    { name: "Adaptabilidad / flexibilidad", value: "0" }
  ];

  habilidadesComerciales: any[] = [
    { name: "Dotes comerciales", value: "0" },
    { name: "Gestión de cliente / cuenta", value: "0" },
    { name: "Orientación al cliente", value: "0" },
    { name: "Negociación", value: "0" }
  ];

  habilidadesComunicacion: any[] = [
    { name: "Capacidad de oratoria", value: "0" },
    { name: "Capacidad de persuasión (positiva)", value: "0" }
  ];

  habilidadesLiderazgo: any[] = [
    { name: "Toma de decisiones", value: "0" },
    { name: "Visión estratégica", value: "0" },
    { name: "Resolución de problemas", value: "0" }
  ];

  isLoading = false;
  errorMessage = '';
  selectedCualities: any = {
    "technicalSkills": false,
    "personalManagementSkills": false,
    "ethicalAndProfessionalSkills": false,
    "commercialAndClientSkills": false,
    "communicationSkills": false,
    "leadershipSkills": false
  };

  selected_idioms: any[] = [];
  jobOfferForm: FormGroup;
  selected_similar_profiles: any[] = [];

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, private fb: FormBuilder, public dialog: MatDialog, private translate: TranslateService) { 
    this.jobOfferForm = this.fb.group({
      specialty_area: ["", Validators.required],
      role_name: ["", Validators.required],
      role_seniority: ["0", Validators.required],
      idioms: [""],
      idiomslevel: [""],
      similar_profiles: [""],
      languages: ["", Validators.required],
      remote_days: ["0"],
      location: ["", Validators.required],
      benefits: [""],
      min_salary: ["0", [Validators.required, Validators.min(0)]],
      max_salary: ["0", [Validators.required, Validators.min(0)]],
      step : ["1"],
      offer_id: [""],
      textual_description: [""],
    });


  }


  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      const offerId = params['offer_id'];
      if (offerId) {
        this.loadJobOffer(offerId);
        this.offerId = offerId;
      }
    });  

    this.http.post(environment.url + '/api/data/keywords-categories', {}).subscribe((data: any) => {

      this.origininalKeywordCategoriesData = data;
      this.keywordsCategories = Object.keys(data);
      this.keywordsCategories.forEach((category: any) => {
          this.selectedKeywordsCategories[category] = [];
          this.filteredKeywordsCategories[category] = [];
      });

      
      
    });
  
  }
  
  status = 0

  goToStep(step: number) {
    this.router.navigate(['/dashboard/company/create-job-offer/step-' + step], { queryParams: { offer_id: this.jobOfferForm.value["offer_id"] } });
  } 

  addcategory(category: any) {
    this.jobOfferForm.get("specialty_area")?.setValue(category.name);
  }

  addidiom() {
    const idioms = {
      "id": this.jobOfferForm.get('idioms')?.value,
      "language": this.get_lang(this.jobOfferForm.get('idioms')?.value),
      "proficiency": this.jobOfferForm.get('idiomslevel')?.value
    }

    if (this.selected_idioms && this.selected_idioms.find(idiom => idiom.id === idioms.id && idiom.proficiency !== idioms.proficiency)){
      this.selected_idioms = this.selected_idioms.map(idiom => {
        if (idiom.id === idioms.id) {
          return idioms;
        }
        return idiom;
      });
      this.jobOfferForm.get('idioms')?.setValue(null);
      this.jobOfferForm.get('idiomslevel')?.setValue(null);
      this.jobOfferForm.get('languages')?.setValue(this.selected_idioms);
    }

    if (this.selected_idioms && this.selected_idioms.find(idiom => idiom.id === this.jobOfferForm.get('idioms')?.value) || idioms.id === null || idioms.proficiency === null
    || this.selected_idioms.find(idiom => idiom.id === idioms.id) || idioms.id === "" || idioms.proficiency === ""
  ){
      return;
    }
    else{
      this.selected_idioms.push(idioms);
      this.jobOfferForm.get('idioms')?.setValue(null);
      this.jobOfferForm.get('idiomslevel')?.setValue(null);
      this.jobOfferForm.get('languages')?.setValue(this.selected_idioms);
    }
  }

  deleteidiom(idiom: any) {
    this.selected_idioms = this.selected_idioms.filter((item) => item !== idiom);
    this.jobOfferForm.get('languages')?.setValue(this.selected_idioms);
  }

  get_lang(id: number) {
    return this.languages.find(lang => lang.id === id)?.name;
  }

  agregarQueryParam(id:any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { offer_id: id },
      queryParamsHandling: 'merge',
    });
  }


  check_if_idiom_is_selected() {
    if (this.jobOfferForm.get('idioms')?.value === null || this.jobOfferForm.get('idiomslevel')?.value === null){
      console.log("idioma no seleccionado")
      return false;
    }
    else{
      console.log("por aqui")
      this.addidiom();
      return true;
    }
  }


  message_saved:string = "";


  save_progress(isnext: boolean = false) {
    this.loading = true;
    this.formHasError = false;
    this.nameError = false;
    console.log(this.jobOfferForm.valid);

    const accessToken = getCookie('access_token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${accessToken}`
        });
        this.check_if_idiom_is_selected();

        if (this.jobOfferForm.valid || !isnext){

          if (this.jobOfferForm.get('similar_profiles')?.value){
            this.addsimilarprofile();
          }

          this.jobOfferForm.get('similar_profiles')?.setValue(this.selected_similar_profiles.join(","));

          let values = this.jobOfferForm.value;

          this.jobOfferForm.get('similar_profiles')?.setValue("");

          values["languages"] = values["languages"] === "" ? [] : values["languages"];

          this.http.post(environment.url + '/api/v1/jobOfferStep1', values, { headers: headers }).subscribe(
            (data: any) => {
              data = data.joboffer;
              const id = data.id;

              //upload file asynchronously
              this.onUpload(id);

              if (isnext) {
                this.router.navigate(['/dashboard/company/create-job-offer/step-2'], { queryParams: { offer_id: id } });
              }
              else{
                this.jobOfferForm.get('offer_id')?.setValue(id);
              // we set the offer id param in the actual url
              this.agregarQueryParam(id);


              this.offerId = data.id;
              this.loading = false;

              this.dialog.open(ModalGeneralComponent, {
                data: {
                  title: this.translate.instant('createJobOffer.step1.modals.progressSaved.title'),
                  message: this.translate.instant('createJobOffer.step1.modals.progressSaved.message'),
                  buttonText: this.translate.instant('createJobOffer.step1.modals.progressSaved.buttonText'),
                  type: 'success'
                }
              });
              }
              
            },
            (error) => {
              console.log(error);
              this.loading = false;
              this.dialog.open(ModalGeneralComponent, {
                data: {
                  title: this.translate.instant('createJobOffer.step1.modals.error.title'),
                  message: this.translate.instant('createJobOffer.step1.modals.error.message'),
                  buttonText: this.translate.instant('createJobOffer.step1.modals.error.buttonText'),
                  type: 'error'
                }
              });
            });
        }
  else{
    this.markAllAsTouched();
   this.formHasError = true;
    this.nameError = true;

    this.dialog.open(ModalGeneralComponent, {
      data: {
        title: this.translate.instant('createJobOffer.step1.modals.fillFields.title'),
        message: this.translate.instant('createJobOffer.step1.modals.fillFields.message'),
        buttonText: this.translate.instant('createJobOffer.step1.modals.fillFields.buttonText'),
        type: 'error'
      }
    });

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300); // Adjust the delay time (in milliseconds) as needed
    this.loading = false;
  }

   
  }


  nextStep() {
    this.check_if_idiom_is_selected()
    if (this.jobOfferForm.valid){
      this.save_progress(true);
    }
    else{
      this.nameError = true;
      this.formHasError = true;
      if (this.selected_idioms.length === 0){
        this.languagesError = true;
        const addIdiomElement = document.getElementById('add-idiom');
        if (addIdiomElement) {
            addIdiomElement.scrollIntoView({ behavior: 'smooth' });
        }
        return;
      }

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300); // Adjust the delay time (in milliseconds) as needed
    }
  }

  goBack() {
    this.router.navigate(['/dashboard/company']);
  }

  loadJobOffer(offerId: number) {
    const accessToken = getCookie('access_token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${accessToken}`
        });

    this.http.get(environment.url + '/api/v1/getjobOffer', {headers: headers, params: {offer_id: offerId}}).subscribe((data: any) => {
      let offer = data["joboffer"];

      // we need to convert the languages to the selectedLanguages format
      this.status = offer["status"]
      this.selected_idioms = offer["languages"] || [];
      if (offer["similar_profiles"]){
        this.selected_similar_profiles = offer["similar_profiles"].split(",");
        offer["similar_profiles"] = "";
      }
      this.jobOfferForm.patchValue(offer);
      
      if (offer["offer_file"]){
        this.selectedFileName = offer["offer_file"].split("\\").slice(-1)[0];
      }

      this.jobOfferForm.get("offer_id")?.setValue(offer.id);
      

    }, (error: any) => {
      console.log(error);
    });

  }


  extractGeneralCategories(node: any): string[] {
    let generalCategories: any[] = [];

    if (node.children) {
      node.children.forEach((child: any) => {
        generalCategories.push({"name": child.name_es, "id": child.id});
      });
    }

    return generalCategories;
  }

  getChildNodesById(nodeId: string): string[] {
    let foundNode = this.findNodeById(this.tree_data, nodeId);
    if (foundNode) {
      this.jobPositions =  this.extractJobPositions(foundNode);
    }
    return [];
  }

  findNodeById(node: any, nodeId: string): any {
    if (node.id === nodeId) {
      return node;
    }
    if (node.children) {
      for (let child of node.children) {
        let found = this.findNodeById(child, nodeId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  extractJobPositions(node: any): any[] {
    let positions: any[] = [];

    if (node.isJobPosition === true && node.isShownInSearch) {
      positions.push({"name": node.name, "id": node.id});
    }

    if (node.children) {
      node.children.forEach((child: any) => {
        positions = positions.concat(this.extractJobPositions(child));
      });
    }

    return positions;
  }

  selectJobPosition(event: any) {
    const index = this.selectedJobPositions.findIndex((id: any) => id === event.id);
  
    if (index === -1) {
      // If the job position is not in the array, add it
      this.selectedJobPositions.push(event.id);
      this.filterJobPositions.push(event.name); 
    } else {
      // If the job position is already in the array, remove it
      this.selectedJobPositions.splice(index, 1);
      this.filterJobPositions.splice(index, 1); 
    }
  }

  isSelected(langId: number, proficiency?: number): boolean {
    const lang = this.selectedLanguages.find((l: any) => l.id === langId);
    if (lang && (proficiency !== undefined)) {
      return lang.proficiency === proficiency;
    }
    return !!lang;
  }

  
  toggleShowAllLanguages() {
    this.showAllLanguages = !this.showAllLanguages;
  }

  setProficiency(proficiency: number, langId: number) {
    const langIndex = this.selectedLanguages.findIndex((l: any) => l.id === langId);
    if (langIndex !== -1) {
      if (this.selectedLanguages[langIndex].proficiency === proficiency) {
        this.selectedLanguages.splice(langIndex, 1);
      } else {
        this.selectedLanguages[langIndex].proficiency = proficiency;
      }
    } else {
      this.selectedLanguages.push({ id: langId, proficiency: proficiency });
    }
  }

  

  markAllAsTouched() {
    Object.values(this.jobOfferForm.controls).forEach(control => {
      control.markAsTouched();
    });
  } 

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }


  onFileSelected(event: Event) {

    this.selectedFile = (event.target as HTMLInputElement).files![0];
    this.selectedFileName = this.selectedFile.name;

    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      // Logic to handle the file upload or display a preview
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.currentOfferFileUrl = e.target.result;  // Preview the new image
      };
      reader.readAsDataURL(file);
    }
  }

  onUpload(offerId: any): void {
    if (this.selectedFile) {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${getCookie('access_token')}`
      });

      const formData: FormData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      formData.append('offerId', offerId);
      
      this.http.post<any>(`${environment.url}/api/v1/jobOffer/upload_offer_file`, formData, { headers: headers })
        .subscribe(
          response => {
            console.log(response);
          },
          error => {
            alert(`Error uploading file: ${error.error.error}`);
            console.error('Error uploading file', error);
          }
        );
    }
  }


  addsimilarprofile() {
    if (this.jobOfferForm.get('similar_profiles')?.value){
      this.selected_similar_profiles.push(this.jobOfferForm.get('similar_profiles')?.value.replace(/,/g, ''));
      this.jobOfferForm.get('similar_profiles')?.setValue("");
    }
  }

  deletesimilarprofile(similar_profile: any) {
    this.selected_similar_profiles = this.selected_similar_profiles.filter((item: any) => item !== similar_profile);
  }

  addsimilarprofilebycomma(event: any) {
    if (event.key === ','){
      this.addsimilarprofile();
    }
  }


}
